import React from 'react';
import { Search, Bell, RefreshCw } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export const Header = ({ title, subtitle, onRefresh, refreshing, actions }) => {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-4 border-b border-slate-200 bg-white/80 px-6 backdrop-blur-lg">
      <div className="flex-1">
        <h1 className="text-lg font-bold text-slate-900 font-[Manrope]">{title}</h1>
        {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
      </div>
      
      <div className="flex items-center gap-3">
        {actions && <div className="flex items-center gap-2">{actions}</div>}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
          <Input
            placeholder="Rechercher..."
            className="w-64 pl-9 h-9 text-sm bg-slate-50 border-slate-200 focus:bg-white"
            data-testid="search-input"
          />
        </div>
        
        {onRefresh && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onRefresh}
            disabled={refreshing}
            className="h-9 w-9"
            data-testid="refresh-btn"
          >
            <RefreshCw size={16} className={refreshing ? 'animate-spin' : ''} />
          </Button>
        )}
        
        <button className="relative p-2 rounded-full hover:bg-slate-100 text-slate-500 transition-colors">
          <Bell size={18} />
          <span className="absolute top-1 right-1 w-2 h-2 bg-[#FF5A6E] rounded-full"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
